
import * as yup from 'yup';
import { UserType } from '../../types/User';
import { CreateTeacherType, TeacherType } from '../../types/Teacher';

const userSchema = yup.object().shape({
  // name: yup.string().required('Nome é obrigatório'),
  // nuit: yup.string().required('Nuit é obrigatório').matches(/^\d{9}$/, 'Deve ter 9 dígitos'),
  // email: yup.string().email('Email inválido').required('Email é obrigatório'),
  // phoneNumber: yup.string().matches(/^\d{9}$/, 'Número de telemóvel inválido').required('Número de telemóvel é obrigatório'),
  // gender: yup.string().oneOf(['M', 'F'] as const, 'Gênero inválido').required('Gênero é obrigatório'),
  // bi: yup.string().required('BI é obrigatório').matches(/^\d{12}[A-Za-z]$/, "Deve conter 12 dígitos seguidos de 1 letra"),
  // dateOfBirth: yup.string().required('Data de nascimento é obrigatória')
  //   .test('is-date', 'Data inválida', (value) => !value || !isNaN(Date.parse(value)))
  //   .test('is-past', 'Data de nascimento não pode ser no futuro', (value) => !value || new Date(value) <= new Date()),
  // userName: yup.string().required('Nome de utilizador é obrigatório'),
   name: yup.string().required('Nome é obrigatório'),
      isForeign: yup.boolean().default(false),
      bi: yup.string().required("Campo obrigatório")
        .when('isForeign', {
          is: true,
          then: schema => schema.required("Campo obrigatório"),
          otherwise: schema => schema.required('Campo obrigatório')
          .test('is-valid-document', 'Número do documento inválido', (value) => {
            if (!value) return false;
  
            // Conjuntos de regex para os documentos suportados
            const documentRegexes = [
              /^\d{12}[A-Za-z]$/, // BI: 12 dígitos seguidos de uma letra
              /^\d{12}$/, // BISlip: Apenas 12 dígitos
              /^[A-Z]{2}\d{8}$/, // DrivingLicense: 2 letras seguidas de 8 dígitos
              /^\d{13}$/, // VoterCard: 13 dígitos
            ];
  
            // O número deve passar em pelo menos um dos padrões
            return documentRegexes.some((regex) => regex.test(value));
          })
        //  .matches(/^\d{12}[A-Za-z]$/, 'Deve conter 12 dígitos seguidos de 1 letra')
          ,
        })
        ,
      nuit: yup.string().required('Nuit é obrigatório').matches(/^\d{9}$/, "Deve ter 9 digitos")//yup.string().optional()
        // .when('isForeign', {
        //   is: true,
        //   then: schema => schema.nullable().optional(),
        //   otherwise: schema => schema.required('Nuit é obrigatório').matches(/^\d{9}$/, 'Deve ter 9 dígitos'),
        // })
        ,
      email: yup.string().email('Email inválido'),
      phoneNumber: yup.string().matches(/^\d{9}$/, 'Número de telemóvel inválido').required('Número de telemóvel é obrigatório'),
      gender: yup.string().oneOf(['M', 'F'] as const, 'Gênero inválido').required('Gênero é obrigatório'),
      dateOfBirth: yup.string().required('Data de nascimento é obrigatória')
        .test('is-date', 'Data inválida', (value) => !value || !isNaN(Date.parse(value)))
        .test('is-past', 'Data de nascimento não pode ser no futuro',
          (value) => !value || new Date(value) <= new Date()),
      userName: yup.string(),
});

const teacherSchema = yup.object().shape({
  id: yup.string().optional(),
  status: yup.boolean().optional(),
  enrollmentDate: yup.string().optional(),
  teacherUniversalCode: yup.string().optional(),
  endDate: yup.string().optional(),
  startDate: yup.string().optional(),
  idUser: yup.string().optional(),
  idTeacherSupervisor: yup.string().nullable(),
  idDepartament: yup.string(),
  idTeacherDepartament: yup.string(),
  fullname: yup.string().optional(),
  isLinked: yup.boolean().default(true).required(),
  category: yup.string().required("Categoria é obrigatória"),
  academicLevel: yup.string().required("Nível académico é obrigatório"),
  idKnowledgeDomain: yup.string().required("Área de formação é obrigatória"),
  typeContract: yup.string().required("Tipo de contrato é obrigatório"),
});

const documentSchema = yup.object().shape({
  id: yup.string().required('O ID do documento é obrigatório'),
  file: yup.mixed<File>()
    .required('O ficheiro é obrigatório')
    .test('is-file', 'Tipo de ficheiro inválido', (value): value is File => value instanceof File)
});

const teacherDepartamentSchema = yup.object().shape({
  id: yup.string().optional(),
  idTeacher: yup.string().optional(),
  idUniversity: yup.string().optional(),
  idFaculty: yup.string().required("Unidade orgânica é obrigatória"),
  idDepartament: yup.string().required('Departamento é obrigatório'),
  startDate: yup.string().required("Data de ingresso é obrigatória"),
  idTeacherSupervisor: yup.string().nullable(),
  status: yup.boolean().required('Status é obrigatório')
});

export const CreateTeacherFormValidation: yup.ObjectSchema<CreateTeacherType> = yup.object().shape({
  user: userSchema,
  teacher: teacherSchema.required(),
  countryDescription: yup.string(),
  documents: yup.array().of(documentSchema).defined(),
  holdDocuments: yup.array().of(yup.object({
    id: yup.string().optional()
  })).optional(),
  storeDocuments: yup.array().of(yup.object({
    idTeacher: yup.string().optional(),
    id: yup.string().optional(),
    status: yup.boolean().optional(),
    idDocument: yup.string().required(),
    docBase64: yup.mixed().nullable(),
    extension: yup.string().nullable(),
    document: yup.string().nullable(),
    name: yup.string().nullable()
  })).optional(),
  idFaculty: yup.string().optional(),
  idDepartament: yup.string().optional(),
  teacherDepartaments: yup.array().of(teacherDepartamentSchema)
    .min(1, 'Pelo menos um departamento é necessário')
    .defined()
});